import { useESkat } from './useESkat';

export const useESkatVisibility = <
  T extends string | string[],
  R = T extends string ? boolean : boolean[]
>(
  fields: T
): R => {
  const { eSkatData } = useESkat();

  switch (typeof fields) {
    case 'string': {
      if (!eSkatData) return false as R;

      const { UpdatedLoanFields, UpdatedPersonFields } = eSkatData;

      return (UpdatedLoanFields?.includes(fields) ||
        UpdatedPersonFields?.includes(fields)) as R;
    }

    default: {
      if (!eSkatData) return new Array(fields.length).fill(false) as R;

      const { UpdatedLoanFields, UpdatedPersonFields } = eSkatData;

      return fields.map(
        (field) =>
          UpdatedLoanFields?.includes(field) ||
          UpdatedPersonFields?.includes(field)
      ) as R;
    }
  }
};
